import { Button, Table, TableProps, Tag } from "antd";

import { useAuth } from "../../context/AuthContext";
import { Service } from "../../entities/interfaces/service";
import { Link } from "react-router";
import { useStore } from "../../context/StoreContext";
import { useColumnSearch } from "../../hooks/useColumnSearch";

type Props = {
  services: Service[];
  onSelect: (service: Service) => void;
};

const ServiceList = ({ services, onSelect }: Props) => {
  const { user, hasPermission } = useAuth();
  const { selectedStore } = useStore();
  const { getColumnSearchProps } = useColumnSearch<Service>();

  const columns: TableProps<Service>["columns"] = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      ...getColumnSearchProps("name"),
      width: "40%",
    },
    {
      title: "Price",
      hidden: !!!selectedStore,
      key: "phone",
      render: (record: Service) => {
        const price = record.storeServices[0]?.price;
        if (price) {
          return <p>₹{price}</p>;
        } else {
          return <p>Not defined</p>;
        }
      },
    },
    {
      title: "Member Price",
      hidden: !!!selectedStore,
      key: "memberPrice",
      render: (record: Service) => {
        const price = record.storeServices[0]?.memberPrice;
        if (price) {
          return <p>₹{price}</p>;
        } else {
          return <p>Not defined</p>;
        }
      },
    },
    {
      title: "Gender Category",
      key: "gender",
      render: (record: Service) => (
        <p className="capitalize">{record.gender.toLocaleLowerCase()}</p>
      ),
    },
    {
      title: "Duration (Mins)",
      key: "duration",
      dataIndex: "duration",
    },
    {
      title: "Availability",
      key: "status",
      hidden: !!!selectedStore,
      render: (record: Service) => {
        const isActive = record.storeServices[0]?.available;
        return isActive ? (
          <Tag color="green">Available</Tag>
        ) : (
          <Tag color="red">Unavailable</Tag>
        );
      },
    },
  ];

  if (hasPermission("update:services")) {
    columns.push({
      title: "Action",
      key: "action",
      render: (record: any) => {
        return (
          <Link to={`/services/${record.id}`}>
            <Button size="small">Update</Button>
          </Link>
        );
      },
    });
  }

  return <Table dataSource={services} columns={columns} />;
};

export default ServiceList;
